/**
 *  keepAlive 管理 router中需要缓存页面
 *  利用include、exclude属性
 *  注意是组件的名字，不是路由的名字）
 */

const state = {
  cachedViews:[],
}
/* mutations 示例
    TOGGLE_SIDEBAR: state => {
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
    },
    TOGGLE_DEVICE: (state, device) => {
    },
    SYNCHRONOUS: (state, parmas)=>{} 
*/
const mutations = {
  /**
   * 添加缓存页面name
   * @param {Object} state 
   * @param {Array | String} view 
   * @returns 
   */
  ADD_CACHED_VIEW: (state, view) => {
    if (Array.isArray(view)) {
      state.cachedViews = [...new Set(state.cachedViews.concat(view))]
    } else {
      if (state.cachedViews.includes(view)) return
      state.cachedViews.push(view)
    }
    // 去掉无效值
    const index = state.cachedViews.indexOf(null);
    index > -1 && state.cachedViews.splice(index, 1)
  },
  /**
   * 删除对应缓存页面的name
   * @param {Object} state 
   * @param {String} view 
   */
  DEL_CACHED_VIEW: (state, view) => {
    const index = state.cachedViews.indexOf(view)
    index > -1 && state.cachedViews.splice(index, 1)
  },
}
/* actions  示例
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  }, 
*/
const actions = {
  /**
   * 添加缓存页面name
   * @param {Object} dispatch 
   * @param {Array | String} view 
   */
  addView({ dispatch }, view){
    dispatch('addCachedView', view)
  },
  /**
   * 添加缓存页面name
   * @param {Object} commit 
   * @param {Array | String} view 
   */
  addCachedView({ commit }, view) {
    commit('ADD_CACHED_VIEW', view)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}